import { ReactElement } from 'react';
import { Paper, Typography } from '@mui/material';
import { Handle, Position } from '@xyflow/react';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { NODE_SIZES } from '../constants';
import { NodeRendererProps, Node } from '../types';

const useStyles = makeStyles(() =>
  createStyles({
    node: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: (node: Node) => `${NODE_SIZES[node.type].width}px`,
      height: (node: Node) => `${NODE_SIZES[node.type].height}px`,
    },
  }),
);

export const BaseStateNode = ({ data }: NodeRendererProps): ReactElement => {
  const classes = useStyles(data);
  return (
    <Paper className={classes.node}>
      <Typography>{data.id}</Typography>
      {data.prev && <Handle type="target" position={Position.Top} />}
      {(data.next || []).length > 0 && <Handle type="source" position={Position.Bottom} />}
    </Paper>
  );
};
